import type dayjs from 'dayjs';
import { FormFieldType, type FormFieldValuesInput } from '../graphql/generated/graphql.ts';
import { API_DATE_FORMAT } from './dateFormatUtils.ts';

type FormsType = { fields: readonly { readonly id: string; readonly type: string }[] }[] | undefined | null;

// biome-ignore lint/suspicious/noExplicitAny: dynamic form values from Ant Design
export const createFormFieldValues = (forms: FormsType, uiFormValues: any): FormFieldValuesInput[] => {
  // Clone to avoid mutating the form's internal store (getFieldsValue(true) returns it by reference)
  const values = { ...uiFormValues };

  forms
    ?.flatMap(it => it.fields)
    .forEach(field => {
      if (Object.hasOwn(values, field.id)) {
        // we assume every value of a datepicker field is a dayjs instance
        if (field.type === FormFieldType.DATE && values[field.id]) {
          values[field.id] = (values[field.id] as dayjs.Dayjs).format(API_DATE_FORMAT);
        }

        if (!Array.isArray(values[field.id])) {
          values[field.id] = values[field.id] ? [values[field.id]] : [];
        }
      } else {
        values[field.id] = [];
      }
    });

  return Object.entries(values).map(entry => ({
    formFieldId: entry[0],
    values: entry[1] as string[],
  }));
};
